// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UKpX","top":"styles_top__19x-G"};